import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues3, LocalService, Status, TriggeredEvent, Wrapper3 } from '../../../service/local.service';
import { LocationManagementService } from '../../../service/location-management.service';

@Component({
  selector: 'app-location-configuration',
  templateUrl: './location-configuration.component.html',
  styleUrls: ['./location-configuration.component.scss']
})
export class LocationConfigurationComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["location_popup"];
  wrapper: Wrapper3; maxBodyHeight = 0;
  id: string; parentId: '';
  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private locationManagementService: LocationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.wrapper = {
        content: { key: '', v1: this.parentId } as KeyValues3
      } as Wrapper3;
    }
    else {
      this.locationManagementService.getLocation(this.id).subscribe(result => {
        this.wrapper = result;        
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.locationManagementService.saveLocation(this.wrapper).subscribe(result => {
      if (result.status == Status.Success) {
        this.wrapper.content.key = this.id == '' ? result.id : this.id;
        this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      }      
    });
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }
}
